interface IOwnProps {
  patientIds: string[];
  adherenceData: IFormattedPatientAdherenceDetails[];
}

type PatientDataType = IFormattedPatientAdherenceDetails[];

export const PAGINATION_ACTIONS = {
  FIRST_PAGE: 'first',
  NEXT_PAGE: 'next',
  PREVIOUS_PAGE: 'prev',
};

export const updatePatientsSortedById = (
  params: IOwnProps,
): PatientDataType => {
  const { patientIds, adherenceData } = params;
  let patients: IFormattedPatientAdherenceDetails[] = [];
  const dictionary = new Map();

  // create new map in order of insertion for patient ids
  // ? is nesting these loops an anti-pattern? (MW)
  patientIds.forEach((key) => {
    const patientById = adherenceData.find((data) => data.id === key);
    if (patientById) {
      dictionary.set(key, patientById);
    }
  });

  // create new ORDERED patient array
  dictionary.forEach((patient) => {
    patients.push(patient);
  });

  return patients;
};
